
import SphereLogoColor from "../../../../enums/SphereLogoColor";

import { SphereLogoBlYes } from "../../../../assets/img/logos/SphereLogoBlYes.jsx"
import { SphereLogoBlNo } from "../../../../assets/img/logos/SphereLogoBlNo.jsx"
import { SphereLogoWhYes } from "../../../../assets/img/logos/SphereLogoWhYes.jsx"
import { SphereLogoWhNo } from "../../../../assets/img/logos/SphereLogoWhNo.jsx"
import { SphereLogoBluYes } from "../../../../assets/img/logos/SphereLogoBluYes.jsx"
import { SphereLogoBluNoWhite } from "../../../../assets/img/logos/SphereLogoBluNoWhite.jsx"
import { SphereLogoBluNoBlack } from "../../../../assets/img/logos/SphereLogoBluNoBlack.jsx"

function SphereLogo(props) {
    const SphereLogoBluNo = props.hasBlackText ? <SphereLogoBluNoBlack className={props.className} /> : <SphereLogoBluNoWhite className={props.className} />;
    const logo = getLogo(props, SphereLogoBluNo);
    return logo;
}

const getLogo = (props, SphereLogoBluNo) => {
    switch (props.color) {
        case SphereLogoColor.black:
            return (
                props.isIconOnly ? <SphereLogoBlYes className={props.className} /> : <SphereLogoBlNo className={props.className} />
            );
        case SphereLogoColor.white:
            return (
                props.isIconOnly ? <SphereLogoWhYes className={props.className} /> : <SphereLogoWhNo className={props.className} />
            );
        case SphereLogoColor.blue:
            return (
                props.isIconOnly ? <SphereLogoBluYes className={props.className} /> : SphereLogoBluNo
            );
        default: return <SphereLogoBluYes className={props.className} />;
    }
}

export default SphereLogo;